import { RenderedContent } from '@workspace/core-ts/utils';
import { cn } from '@workspace/utils';

export const Loader = () => {
    return (
        <div className="flex justify-center items-center gap-3">
            <div className="w-3 h-3 bg-primary rounded-full animate-bounce"></div>
            <div className="w-3 h-3 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.3s' }}></div>
            <div className="w-3 h-3 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.6s' }}></div>
        </div>
    );
};

interface LoaderScreenProps {
    className?: string;
    text?: RenderedContent;
}

export const LoaderScreen = ({ className, text = 'Veuillez patienter...' }: LoaderScreenProps) => {
    return (
        <div className={cn('h-80 w-full flex flex-col items-center justify-center', className)}>
            <p className="text-primary font-medium mb-5 text-lg">{text}</p>
            <Loader />
        </div>
    );
};
